@if (bucket()) {
  <div class="mt-0.5 flex font-mono text-[12px] font-normal leading-4 tabular-nums text-text-subtle">
    @if (spent !== false) {
      <span class="truncate">
        <span [class.font-bold]="spent < 0" [class.text-brand-primary-strong]="spent < 0">{{
          unsignedBucketTotal | currency: 'USD' : 'symbol' : '1.0-2'
        }}</span>
        /
        {{ bucket().amount | currency: 'USD' : 'symbol' : '1.0-2' }}
        @if ((bucket().fund?.goal ?? 0) > 0) {
          @if ((monthsLeft ?? 0) < 12 && (monthsLeft ?? 0) > 0) {
            ({{ monthsLeft }} months)
          }
          @if ((monthsLeft ?? 0) >= 12 && (monthsLeft ?? 0) < 960) {
            ({{ yearsLeft }} {{ yearsLeft === 1 ? 'year' : 'years' }})
          }
        }
      </span>
    }
    @if (earned !== false) {
      <span class="truncate">
        {{ earned | currency: 'USD' : 'symbol' : '1.0-2' }} / {{ bucket().amount | currency: 'USD' : 'symbol' : '1.0-2' }}
      </span>
    }
    <ng-content />
  </div>
}
